import { Injectable } from '@angular/core'
import { LibrariesExtraProvider } from '@surgetech-eu/core'

@Injectable()
export class ImageSizeLibraryExtraProvider implements LibrariesExtraProvider {
    modify(source, target, libraryName): void {
        if (libraryName === 'imageSize') {
            if (source.description) {
                const parts = source.description.trim().split('x')
                target.extra = {
                    width: parts[0] && Number.parseInt(parts[0].trim(), 10),
                    height: parts[1] && Number.parseInt(parts[1].trim(), 10)
                }
            }
        }
    }
}
